<template>
  <div class="coupon-template">
    <div class="coupon-temp">
      <div class="coupon-temp-body">
        <div>
          <div class="coupon-temp-item">
            {{ coupon_data.coupon_name }}
          </div>
          <div class="coupon-temp-item coupon-temp-item-strong" style="">
            <div>
              <span style="font-size:20px">￥</span>
              <span style="color:#000">{{ datas.value1 | yuan }}</span>
            </div>
            <div v-if="coupon == 'discount'">
              <span style="color:#000">{{ datas.value1 }}</span>
              <span style="font-size:20px">折</span>
            </div>
          </div>
          <div class="coupon-temp-item">
            <div>
              {{ getThreshold() }}
            </div>
          </div>
          <!-- 有效期 -->
          <div class="coupon-temp-item">
            <!-- 满减卷 、 折扣卷 -->
            <!-- <div v-if="
              (coupon == 'normal' || coupon == 'discount') &&
              this.coupon_data.coupon_use_rule
            ">
              {{
                this.coupon_data.coupon_use_rule.coupon_available_time
                  .available_begin_time | dateFormat
              }}
              {{
                this.coupon_data.coupon_use_rule.coupon_available_time
                  .available_end_time | dateFormat
              }}
            </div> -->
            <!-- 现金卷-->
            <div style="font-size: 12px;">
              {{ this.coupon_data.start_time }}
              {{ this.coupon_data.expire_time }}
            </div>
          </div>
        </div>
        <div class="zongxiang">
          <div v-if="datas.key == 'xianjin'">
            现金卷
          </div>
          <div v-if="datas.key == 'manjian'">
            满减卷
          </div>
          <div v-if="datas.key == 'xinyonghu'">
            新用户卷
          </div>
          <div v-if="datas.key == 'fenxiang'">
            分享卷
          </div>
        </div>
      </div>
    </div>
    <!--     <div class="temp-bottom">
      {{ coupon_data.stock_name ? coupon_data.stock_name : datas.stock_name }}
    </div> -->
  </div>
</template>
<script>
import {
  /* getBusifavorCouponInfo,
  getNormalCouponInfo */
  getGeneralCouponInfo
} from "../js/couponInfo.js";
/* import { myFixed } from "@/js/public.js"; */
export default {
  props: ["coupon", "datas"],
  data() {
    return {
      merchant_name: localStorage.getItem("merchant_name"),
      coupon_data: {}
    };
  },
  mounted() {
    console.log("datas", typeof this.datas);
    try {
      this.coupon_data = getGeneralCouponInfo(this.datas);
      console.log("this.coupin_Data================-------------------------------------", this.coupon_data);
    } catch (e) {
      console.log(e);
    }

    /* if (
      this.coupon === "normal" ||
      this.coupon === "discount" ||
      this.coupon === "exchange"
    ) {
      this.coupon_data = getBusifavorCouponInfo(this.datas);
    } else if ((this.coupon === "voucher")) {
      this.coupon_data = getNormalCouponInfo(this.datas);
    } */
  },
  methods: {
    /**
     * 获取卷的使用门槛
     */
    getThreshold() {
      if (this.datas.key === "xinyonghu") {
        return "新用户专享";
      } else if (Number(this.coupon_data.amount_require) > 0) {
        return `满￥${this.coupon_data.amount_require}可用`;
      } else if (this.datas.key === "fenxiang") {
        return "用户分享可用";
      } else {
        return "无使用门槛";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.zongxiang {
  width: 130px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #000 !important;
}

.coupon-template {
  height: 100%;
  width: 100%;
  max-width: 500px;
  cursor: pointer;
}

.coupon-temp {
  width: 100%;
  height: 150px;
  max-width: 300px;
  min-width: 300px;
  border: 2rpx solid rgba(255, 196, 0, 1);
  /* background-clip: text;
  -webkit-mask-image: radial-gradient(circle at 10px,
      transparent 10px,
      #9900ff 10.5px),
    radial-gradient(circle at 0px 0px, #9900ff 0px, transparent 0.5px);
  -webkit-mask-position: -10px, -0px -0px;
  -webkit-mask-size: 100% 36px, 100%;
  -webkit-text-fill-color: transparent;
  -webkit-mask-composite: source-out, destination-over;
  mask-composite: subtract, add; */
  // border-radius: 10px;

  .coupon-temp-body {
    // width: calc(100% - 40px);
    padding-left: 40px;
    height: 150px;
    background: linear-gradient(135deg, #fff 0%, #fef9e6 100%);
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
    transition: all 0.25s ease;
    border: 2px solid rgba(255, 196, 0, 1);

    /* background: linear-gradient(#ff004b63, #ff004b);
    -webkit-mask-image: radial-gradient(circle at right 130px bottom 16px,
        transparent 16px,
        red 16.5px),
      radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
    -webkit-mask-size: 100%, 4px 15px;
    -webkit-mask-repeat: repeat, repeat-y;
    -webkit-mask-position: 0 16px, calc(100% - 128px);
    -webkit-mask-composite: source-out; */
    mask-composite: subtract;
    display: flex;
    justify-content: space-between;

  }
}

.coupon-temp-item {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  color: #000 !important;
  font-size: 14px;
  font-weight: 700;
}

.coupon-temp-item-strong {
  height: 60px;
  font-size: 45px;
}

.temp-bottom {
  height: 28px;
  // color: #fff;
  font-size: 20px;
}
</style>
